import React from 'react';
import { ReportTheme } from '../../types';

interface OrganicCTRNumberWidgetProps {
  data: any;
  data_points?: string[];
  report_start_date?: string;
  report_end_date?: string;
  reportTheme: ReportTheme;
}

export const OrganicCTRNumberWidget: React.FC<OrganicCTRNumberWidgetProps> = ({ 
  data, 
  data_points,
  report_start_date,
  report_end_date,
  reportTheme 
}) => {
  console.log('OrganicCTRNumberWidget raw data:', data);

  // Process the raw API data internally for CTR
  const processData = () => {
    if (!data || !data.data || typeof data.data !== 'object') {
      console.warn('OrganicCTRNumberWidget: Invalid data structure');
      return null;
    }

    const rawData = data.data;
    const entries = Object.entries(rawData);
    
    if (entries.length === 0) {
      console.warn('OrganicCTRNumberWidget: No data entries found');
      return null;
    }

    const firstEntry = entries[0];
    const [, firstDayData] = firstEntry;
    
    if (!firstDayData || typeof firstDayData !== 'object' || !(firstDayData as any).date) {
      console.warn('OrganicCTRNumberWidget: Invalid data format');
      return null;
    }

    if (typeof (firstDayData as any).ctr !== 'number') {
      console.warn('OrganicCTRNumberWidget: Missing required metric (ctr)');
      return null;
    }
    
    // Calculate average CTR across all entries
    const validEntries = entries.filter(([dateKey, dayData]: [string, any]) => 
      dayData && typeof dayData === 'object' && typeof dayData.ctr === 'number'
    );

    if (validEntries.length === 0) {
      return null;
    }

    const totalCTR = validEntries.reduce((sum, [dateKey, dayData]: [string, any]) => 
      sum + (dayData.ctr || 0), 0
    );

    return (totalCTR / validEntries.length) * 100; // Convert to percentage
  };

  const ctrValue = processData();

  if (ctrValue === null) {
    return null;
  }

  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className={`text-3xl font-bold mb-2 ${
        reportTheme.theme === 'light' ? 'text-gray-900' : 'text-foreground'
      }`}>
        {ctrValue.toFixed(2)}%
      </div>
      <div className={`text-sm ${
        reportTheme.theme === 'light' ? 'text-gray-600' : 'text-muted-foreground'
      }`}>Average CTR</div>
    </div>
  );
};
